import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'draft-js/dist/Draft.css';
import './index.less';
import * as serviceWorker from './serviceWorker';
import './i18n';
import AppSelector from './appSelector';
import { isWindows } from './utils/browser';

// Note: StrictMode intentionally omitted — findDOMNode warnings with Ant Design
const container = document.getElementById('root');
const root = createRoot(container);
// Ascenseurs visibles sous Windows (cf. .is-windows dans index.less).
if (isWindows()) document.documentElement.classList.add('is-windows');
root.render(<AppSelector />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
